import React from "react";
import IPage from "../../interfaces/page"
import TrainingsComponent from "../../components/Trainings/Trainings.component";

const TrainingsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <TrainingsComponent></TrainingsComponent>;
};

export default TrainingsPage;
